import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';
import { skeletonLoadingImage } from '../../../helpers/animation.js';

var _a;
var CardSkeletonContainer = styled.article({
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: tokens.color.yeezy[0],
    width: "100%",
    height: "100%",
});
var LoadingImageContainer = styled.div(skeletonLoadingImage, {
    width: "100%",
    height: "100%",
    aspectRatio: "1",
});
var Footer = styled.footer((_a = {
        width: "100%",
        minHeight: "7.75rem",
        padding: "".concat(tokens.spacing[4], " ").concat(tokens.spacing[3], " ").concat(tokens.spacing[3])
    },
    _a[mediaQuery.m.min] = {
        minHeight: "6.5rem",
    },
    _a));
var LoadingText = styled.div(skeletonLoadingImage, function (_a) {
    var width = _a.width;
    return ({
        height: "0.625rem",
        width: width,
        marginBottom: tokens.spacing[3],
    });
});

export { CardSkeletonContainer, Footer, LoadingImageContainer, LoadingText };
//# sourceMappingURL=ProductCardSkeleton.styles.js.map
